import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import KeyOutlinedSvg from "@ant-design/icons-svg/es/asn/KeyOutlined";
import AntdIcon from "../components/AntdIcon";
var KeyOutlined = function KeyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: KeyOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  KeyOutlined.displayName = 'KeyOutlined';
}
export default /*#__PURE__*/React.forwardRef(KeyOutlined);